import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a copyright icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <CopyrightIcon width={12} />
 */
const CopyrightIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M1 24.13V24a23 23 0 0 1 46-.13V24a23 23 0 0 1-46 .13zM44.33 24v-.13A20.06 20.06 0 0 0 24.06 3.54
        20.23 20.23 0 0 0 3.67 24v.13a20.06 20.06 0 0 0 20.27 20.33A20.23 20.23 0 0 0 44.33 24zm-32.59-.19v-.13A12.41
        12.41 0 0 1 24.44 11a12.67 12.67 0 0 1 9.66 3.75l-3.49 4.07a9.14 9.14 0 0 0-6.16-2.73c-4.07 0-7 3.37-7
        7.5v.13c0 4.07 2.86 7.5 7 7.5 2.73 0 4.38-1.14 6.29-2.86l3.56 3.56a12.47 12.47 0 0 1-10 4.38 12.3 12.3
        0 0 1-12.56-12.49z`}
        />
    </SvgIcon>
)

CopyrightIcon.defaultProps = defaultProps

export { CopyrightIcon }
